import store from 'stores/store'
import { useQuery } from '@tanstack/react-query'
import { fetchLastPriceForMints } from '../utils/tokens'
import { milliseconds } from 'date-fns'

export function useMarketTokensWithPrices() {
  const baseMint = store((s) => s.market.baseToken.mint)
  const quoteMint = store((s) => s.market.quoteToken.mint)
  const marketMints = [baseMint, quoteMint].filter((mint) => !!mint)

  const {
    data: marketMintPrices,
    isLoading: pricesLoading,
    refetch: refetchMarketPrices,
  } = useQuery({
    queryKey: ['market-token-prices', marketMints],
    queryFn: async () =>
      (await fetchLastPriceForMints(marketMints)).reduce(
        (acc, { mint, price }) => {
          acc[mint] = price
          return acc
        },
        {} as Record<string, number>,
      ),
    cacheTime: milliseconds({ minutes: 30 }),
    staleTime: milliseconds({ minutes: 30 }),
    retry: 3,
    refetchInterval: milliseconds({ seconds: 30 }),
    refetchOnWindowFocus: false,
  })

  const baseMintPrice = baseMint ? (marketMintPrices?.[baseMint] ?? 0) : 0
  const quoteMintPrice = marketMintPrices?.[quoteMint] ?? 0

  return {
    baseMintPrice,
    quoteMintPrice,
    pricesLoading,
    refetchMarketPrices,
  }
}
